import React, { useMemo, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import styled from "styled-components";
import ExcelBtn from "../../../component/atoms/button/excelBtn";
import DatePicker from "../_components/datePicker";
import Modal from "../../../component/templates/Modal";
import TableText from "./../../../component/atoms/text/table/tableText";
import { formatNumberWithCommas } from "./../../../util/formatNumber";
import AnalyticsApi from "../../../api/analytics.api";
import moment from "moment";
import getToday from "../../../util/getToday";
import clientPageData from "../../../constants/clientPageData";
import { toast } from "react-toastify";

// TODO : API 요청 오류로 함수 주석 처리

const StatisticsMostVisited = () => {
  const today = useMemo(() => getToday(), []);

  const [popupIsOpen, setPopupIsOpen] = useState(false);

  const [selectedStartDate, setSelectedStartDate] = useState("");

  const [selectedEndDate, setSelectedEndDate] = useState("");

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");

  const [mostVisitedData, setMostVisitedData] = useState([]);
  const pageName = useMemo(() => clientPageData, []);

  const getMostVisitedData = async () => {
    if (selectedStartDate === "" && selectedEndDate !== "") {
      setModalIsOpen(true);
      setModalTitle("날짜 선택 오류");
      setModalText("시작 날짜를 선택해주세요.");
      setSelectedStartDate("");
    } else if (selectedEndDate !== "" && selectedStartDate > selectedEndDate) {
      setModalIsOpen(true);
      setModalTitle("날짜 선택 오류");
      setModalText("끝 날짜가 시작 날짜보다 빠를 수 없습니다.");
      setSelectedEndDate("");
    }

    try {
      const data = {
        endDate: selectedEndDate
          ? moment(selectedEndDate).format("YYYY-MM-DD")
          : today,
        startDate: moment(selectedStartDate).format("YYYY-MM-DD"),
      };

      const response = (await AnalyticsApi.getListMostVisited(data)).data;

      if (response) {
        const processedData = response?.map((item) => {
          // const cleanedPath = item.pagePath.replace("/home", "");
          const path = item.pagePath;

          if (path === "/") {
            const homePage = pageName.find((page) => page.path === "/");
            return {
              ...item,
              pagePath: path,
              title: homePage ? homePage.title : "홈",
            };
          }

          const matchedPage = pageName.find((page) => path.includes(page.path));

          return {
            ...item,
            pagePath: path,
            title: matchedPage ? matchedPage.title : "Unknown",
          };
        });

        setMostVisitedData(processedData);
      } else {
        toast(
          <>
            데이터를 불러오는 중 오류가 발생했습니다.
            <br />
            구글 애널리틱스에서 확인해주세요.
          </>
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle
            style={{
              marginBottom: 30,
            }}
          >
            많이 방문한 페이지
          </TableTitle>

          <ContentContainer>
            <ContentHeader>
              <DatePicker
                popupIsOpen={popupIsOpen}
                onClick={() => {
                  setPopupIsOpen(!popupIsOpen);
                }}
                startDate={selectedStartDate}
                startDateHandler={(date) => {
                  setSelectedStartDate(date);
                }}
                endDate={selectedEndDate}
                endDateHandler={(date) => {
                  setSelectedEndDate(date);
                }}
                footerBtnHandler={() => {
                  getMostVisitedData();
                  setPopupIsOpen(false);
                }}
              />
              {/* <ExcelBtn /> */}
            </ContentHeader>
            <table
              style={{
                width: "100%",
                borderSpacing: 0,
                borderCollapse: "collapse",
                marginTop: 20,
              }}
            >
              <colgroup>
                {/* 합계: 1044px */}
                {/* 제목 */}
                <col width="368px" />
                {/* URL */}
                <col width="506px" />
                {/* 조회 */}
                <col width="170px" />
              </colgroup>
              <thead>
                <tr
                  style={{
                    height: 41,
                    backgroundColor: "#313233",
                    borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                        paddingLeft: 30,
                      }}
                    >
                      제목
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      URL
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      조회
                    </TableText>
                  </th>
                </tr>
              </thead>
              <tbody>
                {mostVisitedData.map((item, index) => {
                  return (
                    <>
                      <tr
                        key={index}
                        style={{
                          height: 59,
                          borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                        }}
                      >
                        <td>
                          <TableText
                            style={{
                              maxWidth: 328,
                              paddingLeft: 30,
                            }}
                          >
                            {item?.title || "Unknown"}
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              maxWidth: 496,
                            }}
                          >
                            {item?.pagePath || ""}
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              maxWidth: 159,
                            }}
                          >
                            {formatNumberWithCommas(item?.pageViews || 0)}
                          </TableText>
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </ContentContainer>
        </DetailPageLayout>
      </MainLayout>

      {modalIsOpen && (
        <Modal
          type="alert"
          title={modalTitle}
          text={modalText}
          setModalOpen={setModalIsOpen}
          onClick={() => {
            setModalIsOpen(false);
          }}
        />
      )}
    </>
  );
};

export default StatisticsMostVisited;

const ContentContainer = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

const ContentHeader = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
